<template>
<div class="chapter">
<div class="inner_page">
<p class="th1"><a id="page_12"><span class="litpink">Key Lime Blanket</span></a></p><a id="page_12">
<p class="hleft"><span class="litgreen">This simple, fresh baby blanket is created by combining two-by-two rib and Garter stitch in concentric circles. Worked from the center outward, all the increases occur on knit rounds, which makes the counting easy to manage. The off-white center and border mimic the look of a sliced lime.</span></p>
<p class="sh1t"><span class="litpink">FINISHED MEASUREMENTS</span></p>
<p class="normal"><span class="litpink">36" diameter</span></p>
<p class="sh1"><span class="litpink">YARN</span></p>
<p class="normal"><span class="litpink">Berroco Vintage Chunky (50% acrylic / 40% wool / 10% nylon; 100 grams / 130 yards): 6 hanks #6124 Kiwi (MC); 2 hanks #6101 Mochi (A)</span></p>
<p class="sh1"><span class="litpink">NEEDLES</span></p>
<p class="normal"><span class="litpink">One 36" (90 cm) long circular (circ) needle size US 10 (6 mm)</span></p>
<p class="normal"><span class="litpink">One set of five double-pointed needles (dpn) size US 10 (6 mm)</span></p>
<p class="normal"><span class="litpink">Change needle size if necessary to obtain correct gauge.</span></p>
<p class="sh1"><span class="litpink">NOTIONS</span></p>
<p class="normal"><span class="litpink">Stitch marker</span></p>
<p class="sh1"><span class="litpink">GAUGE</span></p>
<p class="normal"><span class="litpink">14 sts and 21 rows = 4" (10 cm) in Stockinette stitch (St st)</span></p>
<p class="sh1"><span class="litgreen">BLANKET</span></p>
<p class="normal">Using dpns and A, CO 8 sts. Divide sts evenly among 4 dpns.</p>
<p class="normal">Join for working in the rnd; pm for beginning of rnd.</p>
<p class="normal"><i>Note: Change to circ needle when necessary for number of sts on needles.</i></p>
<p class="normal"><b>Rnd 1:</b> *K1-tbl; repeat from * to end.</p>
<p class="normal"><b>Rnd 2:</b> *K1, M1; repeat from * to end—16 sts.</p>
<p class="normal"><b>Rnd 3:</b> Knit.</p>
<p class="normal"><b>Rnd 4:</b> Repeat Rnd 2—32 sts.</p>
<p class="normal"><b>Rnd 5:</b> Purl.</p>
<p class="normal"><b>Rnd 6:</b> Knit.</p>
<p class="normal"><b>Rnd 7:</b> Purl.</p>
<p class="normal"><b>Rnd 8:</b> *K2, M1; repeat from * to end—48 sts.</p>
<p class="normal"><b>Rnds 9 and 11:</b> Knit.</p>
<p class="normal"><b>Rnds 10 and 12:</b> Purl.</p>
<p class="normal"><b>Rnd 13:</b> *K4, M1; repeat from * to end—60 sts.</p>
<p class="normal"><b>Rnds 14-18:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 19:</b> Change to MC; knit.</p>
<p class="normal"><b>Rnd 20:</b> *K15, M1; repeat from * to end—64 sts.</p>
<p class="normal"><b>Rnd 21:</b> Purl.</p>
<p class="normal"><b>Rnd 22:</b> Knit.</p>
<p class="normal"><b>Rnd 23:</b> Purl.</p>
<p class="normal"><b>Rnd 24:</b> *K2, M1; repeat from * to end—96 sts.</p>
<p class="normal"><b>Rnds 25-29:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 30:</b> *K3, M1; repeat from * to end—128 sts.</p>
<p class="normal"><b>Rnd 31:</b> Purl.</p>
<p class="normal"><b>Rnd 32:</b> Knit.</p>
<p class="normal"><b>Rnd 33:</b> Purl.</p>
</a><p class="normal"><a id="page_12"></a><a id="page_13"><b>Rnd 34:</b> *K4, M1; repeat from * to end—160 sts.</a></p><a id="page_13">
<p class="normal"><b>Rnds 35-41:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 42:</b> *K5, M1; repeat from * to end—192 sts.</p>
<p class="normal"><b>Rnd 43:</b> Purl.</p>
<p class="normal"><b>Rnd 44:</b> Knit.</p>
<p class="normal"><b>Rnd 45:</b> Purl.</p>
<p class="normal"><b>Rnd 46:</b> *K6, M1; repeat from * to end—224 sts.</p>
<p class="normal"><b>Rnds 47-55:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 56:</b> *K7, M1; repeat from * to end—256 sts.</p>
<p class="normal"><b>Rnd 57:</b> Purl.</p>
<p class="normal"><b>Rnd 58:</b> Knit.</p>
<p class="normal"><b>Rnd 59:</b> Purl.</p>
<p class="normal"><b>Rnd 60:</b> *K8, M1; repeat from * to end—288 sts.</p>
<p class="normal"><b>Rnds 61-71:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 72:</b> *K9, M1; repeat from * to end—320 sts.</p>
<p class="normal"><b>Rnd 73:</b> Purl.</p>
<p class="normal"><b>Rnd 74:</b> Knit.</p>
<p class="normal"><b>Rnd 75:</b> Purl.</p>
<p class="normal"><b>Rnd 76:</b> *K10, M1; repeat from * to end—352 sts.</p>
<p class="normal"><b>Rnds 77-89:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 90:</b> *K11, M1; repeat from * to end—384 sts.</p>
<p class="normal"><b>Rnd 91:</b> Purl.</p>
<p class="normal"><b>Rnd 92:</b> Knit.</p>
<p class="normal"><b>Rnd 93:</b> Purl.</p>
<p class="normal"><b>Rnd 94:</b> *K12, M1; repeat from * to end—416 sts.</p>
<p class="normal"><b>Rnds 95-109:</b> *K2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnds 110-116:</b> Change to A; *k2, p2; repeat from * to end.</p>
<p class="normal"><b>Rnd 117:</b> Knit.</p>
<p class="normal"><b>Rnd 118:</b> Purl.</p>
<p class="normal"><b>Rnd 119:</b> Knit.</p>
<p class="normal"><b>Rnd 120:</b> Purl. BO all sts knitwise.</p>
<p class="sh1"><span class="litgreen">FINISHING</span></p>
</a><p class="normal"><a id="page_13">Block lightly (see Special Techniques, </a><span href="#/xhtml/55_Special_Techniques#page_156" title="Link target outside of Sample">page 156</span>).</p>
<p class="img_center1"><img alt="img" src="images/page_013.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Chapter02.vue?755550a8